import * as React from "react"

export default
class Notification extends React.Component<NotificationProps> {
	render() {
		const levelClassName =
			this.props.level === NotificationLevel.Danger ? "is-danger" :
			this.props.level === NotificationLevel.Success ? "is-success" :
			this.props.level === NotificationLevel.Warning ? "is-warning" :
			"is-primary"

		const lightClassName = this.props.light ? "is-light" : ""

		const className = `notification ${levelClassName} ${lightClassName}`.trim()

		return <div className={className}>
			{this.props.onClickCloseButton &&
			<button
			className="delete"
			type="button"
			onClick={e => this.props.onClickCloseButton(e)} />}

			{this.props.message}
			{this.props.detail && <p>{this.props.detail}</p>}
		</div>
	}
}

export enum NotificationLevel {
	Danger,
	Success,
	Warning
}

export interface NotificationProps {
	detail?: string;
	level?: NotificationLevel;
	light?: true;
	message: React.ReactChild;
	onClickCloseButton?(e: React.SyntheticEvent<Element>): void
}

export interface NotificationParams {
	level: NotificationLevel;
	message: string;
	symbol: Symbol;
	error?: Error;
}



// WEBPACK FOOTER //
// ./src/component/notification/index.tsx